import { createAction, props } from '@ngrx/store';
import { IRejectionReason } from '../models/rejection-reason.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';

export const loadUploadedFileRejectionReasons = createAction('[UploadedFileRejectionReason] Load UploadedFileRejectionReasons');

export const loadUploadedFileRejectionReasonsSuccess = createAction(
  '[UploadedFileRejectionReason] Load UploadedFileRejectionReasons Success',
  props<{ response: IRejectionReason[] }>()
);

export const loadUploadedFileRejectionReasonsFailure = createAction(
  '[UploadedFileRejectionReason] Load UploadedFileRejectionReasons Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
